import {Component, EventEmitter, HostListener, Input, OnInit, Output} from '@angular/core';
import {GridFormComponent} from '../grid-form.component';
import {FormStatus, LanguagesService} from '../../../../core';

@Component({
  selector: 'gc-search-pane',
  templateUrl: './search-pane.component.html',
  styleUrls: ['./search-pane.component.css']
})
export class SearchPaneComponent implements OnInit {
  FormStatusEnum = FormStatus;
  constructor(public lang: LanguagesService) { }

  @Input()
  get visible(): boolean {
    return this.dialogVisible;
  }
  set visible(v) {
    this.init();
    this.dialogVisible = v;
  }
  @Output() visibleChange = new EventEmitter<boolean>();

  @Input() title = '';
  @Input() view = true;
  @Input() form: GridFormComponent;

  dialogVisible = false;
  maxHeight = 100;

  ngOnInit(): void {
    this.resize();
  }

  close(): void {
    this.visibleChange.emit(false);
    this.dialogVisible = false;
  }

  @HostListener('window:resize', ['$event'])
  onResize(_): void {
    this.resize();
  }

  resize(): void {
    this.maxHeight = window.innerHeight - 200;
  }

  search(): void {
    // Apply to Search Info
    // Search
    const searchInfo: { [key: string]: any } = {};
    Object.keys(this.form.searchCacheSearchPane).forEach(field => {
      const searchCache = this.form.searchCacheSearchPane[field];
      if (searchCache.searchNull || searchCache.value1 || searchCache.value2 || (searchCache.values && searchCache.values.length > 0)) {
        searchInfo[field] = searchCache;
      }
    });

    this.form.searchBySearchPane = true;
    // Reset filter
    this.form.filterDescriptor.filters = [];
    this.form.define.searchInfo = searchInfo;
    this.form.define.pageIndex = 1;
    this.form.load();

    this.visibleChange.emit(false);
    this.dialogVisible = false;
  }

  init(): void {
    if (!this.form || !this.form.define || !this.form.define.searchInfo) {
      return;
    }
    // Work with Search Info
    Object.keys(this.form.define.searchInfo).forEach(field => {
      const searchCacheSrc = this.form.define.searchInfo[field];
      const searchCacheDes = this.form.createSearchCacheField(this.form.define.fieldByNames[field]);
      searchCacheDes.values = searchCacheSrc.values;
      searchCacheDes.value2 = searchCacheSrc.value2;
      searchCacheDes.value1 = searchCacheSrc.value1;
      searchCacheDes.type = searchCacheSrc.type;
      if (!searchCacheDes.value1 && !searchCacheDes.value2 && (!searchCacheDes.values || searchCacheDes.values.length === 0)) {
        searchCacheDes.searchNull = true;
      }
      searchCacheDes.searchNull = true;
      this.form.searchCacheSearchPane[field] = searchCacheDes;
    });
  }

  reset(): void {
    this.form.define.fields.forEach(field => {
      this.form.searchCacheSearchPane[field.name] = this.form.createSearchCacheField(field);
    });
  }
}
